var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.201,
    height: 14.2,
    viewBox: "0 0 14.201 14.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#bbc1c3;stroke:#bac0c2;stroke-width:0.2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.9 -10.9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bbc1c3",
    stroke: "#bac0c2",
    strokeWidth: "0.2px",
    d: "M24.829,24.006,21.463,20.64a5.9,5.9,0,1,0-.826.826L24,24.829a.583.583,0,1,0,.826-.823ZM16.9,21.626A4.727,4.727,0,1,1,21.629,16.9,4.732,4.732,0,0,1,16.9,21.626Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1868d26b9678f600b861d0c977b0fe16.svg";
export { ForwardRef as ReactComponent };